var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "edit_square"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_759_4773",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_759_4773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "edit_square_2",
    d: "M4.75625 17.0833C4.38114 17.0833 4.06407 16.9537 3.80505 16.6947C3.54602 16.4357 3.4165 16.1186 3.4165 15.7435V5.2564C3.4165 4.88128 3.54602 4.56421 3.80505 4.30519C4.06407 4.04616 4.38114 3.91665 4.75625 3.91665H10.9565L9.87323 4.99996H4.75625C4.69214 4.99996 4.63337 5.02667 4.57994 5.08008C4.52652 5.13351 4.49982 5.19229 4.49982 5.2564V15.7435C4.49982 15.8076 4.52652 15.8664 4.57994 15.9198C4.63337 15.9732 4.69214 16 4.75625 16H15.2434C15.3075 16 15.3663 15.9732 15.4197 15.9198C15.4731 15.8664 15.4998 15.8076 15.4998 15.7435V10.6762L16.5831 9.57208V15.7435C16.5831 16.1186 16.4536 16.4357 16.1946 16.6947C15.9356 16.9538 15.6185 17.0833 15.2434 17.0833L4.75625 17.0833ZM13.9213 3.97594L14.7162 4.77079L9.49982 9.93746V11H10.5623L15.7658 5.83329L16.503 6.59929L11.3764 11.7339C11.2503 11.86 11.1134 11.9497 10.9656 12.0031C10.8178 12.0566 10.6634 12.0833 10.5023 12.0833H9.09017C8.90068 12.0833 8.74104 12.0194 8.61123 11.8917C8.48141 11.7639 8.4165 11.6045 8.4165 11.4134V10.0177C8.4165 9.85844 8.44787 9.70169 8.51061 9.54746C8.57334 9.39324 8.6611 9.25882 8.77388 9.14421L13.9213 3.97594ZM16.503 6.59929L13.9213 3.97594L15.5159 2.3814C15.7715 2.12713 16.0825 2 16.4488 2C16.8151 2 17.128 2.1298 17.3876 2.38942L18.1131 3.1044C18.3762 3.36917 18.5078 3.68485 18.5078 4.05144C18.5078 4.41801 18.3753 4.73151 18.1104 4.99194L16.503 6.59929Z",
    fill: "#6B7280"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSquare);
export default __webpack_public_path__ + "static/media/edit_square.1f8c271359036f73fd56457d293c5461.svg";
export { ForwardRef as ReactComponent };